import { storyblokEditable } from "gatsby-source-storyblok"
import React from "react"

import SocialProof from "../../../V2/Banners/SocialProof"

const StoryblokSocialProofBanner = ({
  blok,
  mobileGridOrder,
}: Storyblok.BlokProps<Storyblok.SocialProofBanner>) => {
  return (
    <SocialProof
      backgroundColor={blok.backgroundColor}
      title={blok.title}
      primaryImageUrl={blok.primaryImage.filename}
      body={blok.body}
      secondaryImageUrl={blok.secondaryImage?.filename || ""}
      overrideTextColor={blok.overrideTextColor}
      mobileGridOrder={mobileGridOrder}
      // @ts-ignore to have more strict typing compared to Storybloks generic object typing
      {...storyblokEditable(blok)}
    />
  )
}

export default StoryblokSocialProofBanner
